<template>
  <div class="d-inline-block text-center">
    <router-link :to="to || '/'" :custom="!to">
      <v-avatar v-if="image" variant="text" :size="circleSize" :image="image"></v-avatar>

      <v-avatar v-if="!image" variant="tonal" :color="color" :size="circleSize">
        <v-icon v-if="iconOnly" :color="color" :size="circleSize - 10" :icon="icon"></v-icon>
        <span v-if="!iconOnly" :style="{ 'font-size': initialsFontSize }">{{ initials }}</span>
      </v-avatar>
    </router-link>

    <div v-if="!initialsOnly && !firstNameOnly" :style="{ 'font-size': nameFontSize }">
      {{ name }} <v-icon v-if="badged" class="mb-1" icon="mdi-check-decagram" color="secondary"></v-icon>
    </div>
    <div v-if="firstNameOnly" :style="{ 'font-size': nameFontSize }">
      {{ firstName }} <v-icon v-if="badged" class="mb-1" icon="mdi-check-decagram" color="secondary"></v-icon>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { getInitials } from '@/service/uiUtils.js'

const props = defineProps({
  firstName: { type: String },
  lastName: { type: String },
  name: { type: String },
  firstNameOnly: { type: Boolean },
  nameFontSize: { type: String, default: '12px' },
  color: { type: String, default: 'secondary' },
  initialsOnly: { type: Boolean },
  initialsFontSize: { type: String, default: '16px' },
  circleSize: { type: String, default: '37' },
  iconOnly: { type: Boolean },
  badged: { type: Boolean },
  icon: { type: String, default: 'mdi-account' },
  to: { type: String },
  image: { type: String },
})
const initials = computed(() => getInitials({ firstName: props.firstName, lastName: props.lastName }))
const name = computed(() => props.name || [props.firstName, props.lastName].filter(e => !!e).join(' '))

</script>

<style>
</style>